<template>
    <div class="days">
        <div
            v-for="count in 5"
            :key="count"
            class="day"
            :class="{ selected: count === selectedIdx, irrelevant: count > latestDay }"
            @click="selectDay(count)"
        >
            <span class="label">{{ $translate('day') }}</span>
            <span class="count">{{ count }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Days',
    props: {
        selectedIdx: {
            type: Number,
            required: true
        },
        latestDay: {
            type: Number,
            required: true
        }
    },
    methods: {
        selectDay(count) {
            this.$emit('daySelected', count)
        }
    }
}
</script>

<style lang="scss" scoped>
.days {
    display: flex;
    align-items: center;
    justify-content: center;

    .day {
        padding: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        background-color: $dark-3;
        margin: 0 10px;
        cursor: pointer;

        &.irrelevant {
            background-color: $light;
        }
        &.selected {
            background-color: $pink;
            pointer-events: none;
        }

        @media screen and #{$new-break2close} {
            height: 50px;
            width: 50px;

            .label {
                font-size: 14px;
            }
            .count {
                font-size: 18px;
            }
        }
        @media screen and #{$new-break3open} {
            height: 80px;
            width: 80px;

            .label {
                font-size: 17px;
            }
            .count {
                font-size: 22px;
            }
        }
    }
}
</style>
